import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { DxDataGridComponent, DxScrollViewComponent } from 'devextreme-angular';
import { PoaGestionService } from '../../../services/formulacion/poa-gestion.service';
import { UtilHelper } from '../../../_helpers/util';
declare var toastr;

@Component({
  selector: 'app-poa-gestion',
  templateUrl: './poa-gestion.component.html',
  styleUrls: [],
  providers: [PoaGestionService]
})
export class PoaGestionComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  etapas: any[];
  dataResourcePG: any[];
  tituloFormulario: string;
  model: any = {
    id: 0,
    gestion: '',
    descripcion: '',
    estado: '',
    estado_id: '',
    etapa_id: '',
    version: '',
    es_vigente: true
  };
  fuenteId: number;
  popupVisibleAdd: boolean = false;
  popupVisibleDel: boolean = false;
  popupVisibleApr: boolean = false;
  popupVisibleRP: boolean = false;
  state_toogle: boolean = false;
  vigencia: any[];
  modelApr: any = { id: 0, resolucion_ministerial: '', fecha: '', detalle: '' };
  minDate = new Date(2000, 0, 1);
  maxDate = new Date(2029, 12, 31);  
  fechaRM = new Date();
  etapa: string = '';
  poaId: number;
  listMemoria: any[];
  hasError: any;

  constructor(private _ps: PoaGestionService) {
    this.vigencia = [{ text: 'Activo', value: true }, { text: 'Inactivo', value: false }];
    this.clearErrors();
    this.getPoaGestiones();
    this._ps.getPoaEtapas().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.etapas = result.data;
        } else { this.etapas = []; }
      },
      (error) => { console.log('Error', error); });
  }

  ngOnInit() {
  }

  clearErrors() {
    this.hasError = { gestion: false, descripcion: false };
  }

  saveGestionVigencia(data: any) {
    this.model.id = data.id;
    if (this.model.id != 0) {
      this._ps.poaGestionVigencia(this.model).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getPoaGestiones();
          }
        },
        (error) => { console.log('Error', error); });
    }
  }

  getPoaGestiones() {
    this._ps.getPoaGestion().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourcePG = result.data;
        } else { this.dataResourcePG = []; }
      },
      (error) => { console.log('Error', error); });
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  showModalAdd() {
    this.clearErrors();
    this.model.id = 0;
    this.model.gestion = new Date().getFullYear() + 1 ;
    this.model.descripcion = '';
    this.model.estado = '';
    this.model.estado_id = '';
    this.model.etapa_id = '';
    this.model.version = '';
    this.model.es_vigente = true;
    this.state_toogle = false;
    this.popupVisibleAdd = true;
    this.tituloFormulario = 'REGISTRAR GESTIÓN';
  }

  showModalEdit(data: any) {
    this.clearErrors();
    this.model.id = data.id;
    this.model.gestion = data.gestion;
    this.model.descripcion = data.descripcion;
    this.model.estado_id = data.estado_id;
    this.model.etapa_id = data.etapa_id;
    this.model.version = data.version;
    this.state_toogle = true;
    this.popupVisibleAdd = true;
    this.tituloFormulario = 'EDITAR GESTIÓN';
  }

  savePoaGestion() {
    this.clearErrors();
    if (this.validate(this.model)) {
      if (this.model.id == 0) {
        this._ps.postPoaGestion(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getPoaGestiones();
              this.popupVisibleAdd = false;
            }
          },
          (error) => { console.log('Error', error); });
      }
      else {
        this._ps.putPoaGestion(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getPoaGestiones();
              this.popupVisibleAdd = false;
            }
          },
          (error) => { console.log('Error', error); });
      }
    }
  }

  showModalDelete(id: number) {
    this.fuenteId = id;
    this.popupVisibleDel = true;
  }

  deletePoaGestion() {
    this._ps.deletePoaGestion(this.fuenteId).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getPoaGestiones();
          this.dataGrid.instance.refresh();
          this.popupVisibleDel = false;
          toastr.success('Operación realizada exitosamente.');
        } else {
          toastr.warning('Ocurrió un incoveniente al realizar la operación.');
        }
      },
      (error) => { console.log('Error', error); });
  }

  validate(data: any) {
    let res = true;
    if (!UtilHelper.validator(data.gestion, 'text')) {
      this.hasError.gestion = true; res = false;
    }
    if (!UtilHelper.validator(data.descripcion, 'text')) {
      this.hasError.descripcion = true; res = false;
    }
    return res;
  }

  showModalApr(data: any) {    
    this.modelApr.id = data.id;
    this.modelApr.resolucion_ministerial = data.rm_aprobacion;
    this.modelApr.detalle = data.detalle;
    if (data.fecha_aprobacion != '') {      
      this.fechaRM = new Date(data.fecha_aprobacion);
    }
    else
      this.fechaRM = new Date();
    this.popupVisibleApr = true;
  }

  saveEstadoPoaGestion() {
    this.modelApr.fecha = this.convertDate(this.fechaRM);
    this._ps.postPoaGestionAprobacion(this.modelApr).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getPoaGestiones();
          this.dataGrid.instance.refresh();
          this.popupVisibleApr = false;
          toastr.success('Operación realizada exitosamente.');
        } else {
          toastr.warning('Ocurrió un incoveniente al realizar la operación.');
        }
      },
      (error) => { console.log('Error', error); });
  }

  convertDate(date: Date) {
    var dd = date.getDate();
    var mm = date.getMonth() + 1;
    let nd = dd.toString();
    let nm = mm.toString();
    var yyyy = date.getFullYear(); if (dd < 10) { nd = '0' + dd } if (mm < 10) { nm = '0' + mm }
    return nd + '/' + nm + '/' + yyyy;
  }

  showModalRP(data: any) {
    this.poaId = data.id;
    let o = this.etapas.filter(o => o.id == data.etapa_id + 1).map(o => o)[0];
    this.etapa = o.etapa;
    this._ps.getMemoriaEtapas().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.listMemoria = result.data;
        } else { this.listMemoria = []; }
      },
      (error) => { console.log('Error', error); });
    this.popupVisibleRP = true;
  }

  saveReformulacion() {
    this._ps.putReformulacionPoa({ id: this.poaId }).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getPoaGestiones();
          this.dataGrid.instance.refresh();
          this.popupVisibleRP = false;
          toastr.success('Operación realizada exitosamente.');
        } else {
          toastr.warning('Ocurrió un incoveniente al realizar la operación.');
        }
      },
      (error) => { console.log('Error', error); });
  }
}
